<div class="dls-side-nav-header p-3 d-none d-lg-block dls-cursor-pointer" routerLink="/home" tabindex="0">
  <div class="dls-ws-logo pb-1">
    <img
      class="w-100"
      src="./assets/images/logos/WS_DesignLanguageSystem_stacked.svg"
      alt="WellSky Logo">
  </div>
</div>

<mat-nav-list class="dls-side-nav-body p-0 w-100">

  <ng-container *ngFor="let navGroup of sideNavItems; index as i">

    <!-- Navigation Group Title with Dropdown -->
    <mat-list-item *ngIf="navGroup.children" (click)="togglePanel(i)">
      <div class="d-flex justify-content-between w-100 ws-h4 mb-0">
        <div>
          {{navGroup.title}}
        </div>

        <mat-icon [@indicatorRotate]="_getExpandedState(navGroup.expand)">
          arrow_drop_down
        </mat-icon>
      </div>
    </mat-list-item>

    <!-- Navigation Group Title without Dropdown -->
    <mat-list-item *ngIf="!navGroup.children" routerLink="{{navGroup.basePath + '/' + _routeState}}" routerLinkActive
      (click)="togglePanel(i)" [ngClass]="{'active': navGroup.active}">
      <div class="d-flex justify-content-between w-100 ws-h4 mb-0">
        {{navGroup.title}}
      </div>
    </mat-list-item>

    <!-- Secondary Navigation List -->
    <mat-nav-list *ngIf="navGroup.expand && navGroup.children" class="p-0" @bodyExpansion>
      <a mat-list-item [ngClass]="{'active': rla.isActive}" *ngFor="let navItem of navGroup.children;"
        routerLink="{{navItem.route + '/' + _routeState}}" routerLinkActive #rla="routerLinkActive">
        <span>{{navItem.title}}</span>
      </a>
    </mat-nav-list>
  </ng-container>
</mat-nav-list>